import PageWrapper from "../../Wrappers/PageWrapper";

function SuspenseFallback() {
  return (
    <PageWrapper className="flex flex-col gap-6">
      <section className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <div className="h-8 bg-offWhite animate-pulse w-60 rounded-lg" />
          <div className="h-4 bg-offWhite animate-pulse w-32 rounded-lg" />
        </div>
        <div className="h-10 bg-offWhite animate-pulse w-32 rounded-lg" />
      </section>
      <section className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div className="h-10 bg-offWhite animate-pulse w-2/5 rounded-lg" />
          <section className="flex items-center gap-2">
            <div className="h-10 bg-offWhite animate-pulse w-32 rounded-lg" />
            <div className="h-10 bg-offWhite animate-pulse w-32 rounded-lg" />
            <div className="h-10 bg-offWhite animate-pulse w-32 rounded-lg" />
          </section>
        </div>
        <div className="h-[calc(100vh-300px)] rounded-lg bg-offWhite animate-pulse" />
      </section>
    </PageWrapper>
  );
}

export default SuspenseFallback;
